<template>
  <div style="background-image: url('/build/assets/img/icons/banners/YY24 Bg.png'); min-height: 100vh; height: auto; background-size: cover; padding-bottom: 15rem; background-attachment: fixed;">
    <!-- <img src="/build/assets/img/brand/khit_thit.jpg" alt="" /> -->
    <!-- <div class="col-12 d-flex my-0">
      <img
        class="mx-auto"
        src="https://cdn.gold549.com/build/assets/img/brand/logo.png"
        alt=""
        style="width: 120px; height: 120px; margin-top: -22px"
      />
    </div> -->
    <Sticky>
      <div class="bg-white"> 
        <NavBar />
        <div class="col-lg-12 col-12 mx-auto p-0 d-flex main-image-wrapper">
              <b-carousel
                  id="carousel-1"
                  :interval="3000"
                  controls
                  fade
                  style="width: 100%; height: 100%;"
                  v-if="!threedData.embedded_link && !threedData.isLive"
              >
                  <b-carousel-slide
                      img-src="/build/assets/img/icons/banners/banner1.png"
                  ></b-carousel-slide>
                  <b-carousel-slide
                      img-src="/build/assets/img/icons/banners/banner2.png"
                  ></b-carousel-slide>
                  <b-carousel-slide
                      img-src="/build/assets/img/icons/banners/banner3.png"
                  ></b-carousel-slide>
                  <b-carousel-slide
                      img-src="/build/assets/img/icons/banners/banner4.png"
                  ></b-carousel-slide>
                  <b-carousel-slide
                      img-src="/build/assets/img/icons/banners/banner5.png"
                  ></b-carousel-slide>
              </b-carousel>
          </div>

        <div class="col-7 d-flex px-0" style="margin-top: -1.3rem; z-index: 10; padding-left: 10px; padding-top: 5px; padding-bottom: 5px; padding-right: 10px; border-radius: 15px; margin-left: 10px; margin-right: 3px; background: #D02126;">
          <i class="fas fa-volume-up my-auto ml-2 text-white" style="font-size: 14px; font-weight: 600;"></i>
          <NoticeBar
            class="col-lg-10 col-10 mx-0 px-0 mx-auto notice-bar"
            scrollable
            :text="websiteInfo[0]?.noticeText"
            v-if="!threedData.embedded_link && !threedData.isLive"
          />
        </div>

        <div class="my-3 text-center py-2" style="background: linear-gradient(to right, #e89b9e, #f4efef); font-weight: 700; color: black;">
          TOP GAMES
        </div>
      </div>
    </Sticky>
    

    <div class="cards-container-mobile">
      <div class="container-fluid justify-content-end mt-1 px-0 d-flex pt-0">
        <!-- <div class="col-12"> -->
            
						<div class="col-3 pr-0 mx-0 pl-2 index_left sidebar" style="overflow-y: auto; margin-bottom: 25rem; height: 90vh;">
              <div style="height: 110vh;">
                <ul class="nav nav-pills game-nav">
                  <li class="nav-item d-flex">
                    <img class="mx-auto" src="/build/assets/img/icons/2D3D.png" alt="2d3d" style="width: 90%; height: auto;" v-show="sideNav !== '2d3d'" @click="changeSideNav('2d3d'); scrollMeTo()">
                    <img class="mx-auto" src="/build/assets/img/icons/2D3DA.png" alt="2d3d" style="width: 92%; height: auto;" v-show="sideNav === '2d3d'" @click="changeSideNav('2d3d'); scrollMeTo()">
                  </li>
                  <li class="nav-item d-flex">
                    <img class="mx-auto" src="/build/assets/img/icons/Skm.png" alt="skm" style="width: 90%; height: auto;" v-show="sideNav !== 'card' && sideNav !== 'skm' && sideNav !== 'bugyi'" @click="changeSideNav('card'); scrollMeTo()">
                    <img class="mx-auto" src="/build/assets/img/icons/SkmA.png" alt="skm" style="width: 90%; height: auto;" v-show="sideNav === 'card' || sideNav === 'skm' || sideNav === 'bugyi'" @click="changeSideNav('card'); scrollMeTo()">
                  </li>
                  <li class="nav-item d-flex">
                    <img class="mx-auto" src="/build/assets/img/icons/Football.png" alt="football" style="width: 90%; height: auto;" v-show="sideNav !== 'football'" @click="changeSideNav('football'); scrollMeTo()">
                    <img class="mx-auto" src="/build/assets/img/icons/FootballA.png" alt="football" style="width: 92%; height: auto;" v-show="sideNav === 'football'" @click="changeSideNav('football'); scrollMeTo()">
                  </li>
                  <li class="nav-item d-flex">
                    <img class="mx-auto" src="/build/assets/img/icons/Slot.png" alt="slot" style="width: 90%; height: auto;" v-show="sideNav !== 'slot'" @click="changeSideNav('slot'); scrollMeTo()">
                    <img class="mx-auto" src="/build/assets/img/icons/SlotA.png" alt="slot" style="width: 90%; height: auto;" v-show="sideNav === 'slot'" @click="changeSideNav('slot'); scrollMeTo()">
                  </li>
                  <li class="nav-item d-flex">
                    <img class="mx-auto" src="/build/assets/img/icons/Fishing.png" alt="fishing" style="width: 90%; height: auto;" v-show="sideNav !== 'fishing'" @click="changeSideNav('fishing'); scrollMeTo()">
                    <img class="mx-auto" src="/build/assets/img/icons/FishingA.png" alt="fishing" style="width: 90%; height: auto;" v-show="sideNav === 'fishing'" @click="changeSideNav('fishing'); scrollMeTo()">
                  </li>
                  <li class="nav-item d-flex">
                    <img class="mx-auto" src="/build/assets/img/icons/Casino.png" alt="casino" style="width: 90%; height: auto;" v-show="sideNav !== 'casino'" @click="changeSideNav('casino'); scrollMeTo()">
                    <img class="mx-auto" src="/build/assets/img/icons/CasinoA.png" alt="casino" style="width: 90%; height: auto;" v-show="sideNav === 'casino'" @click="changeSideNav('casino'); scrollMeTo()">
                  </li>
                  <li class="nav-item d-flex">
                    <img class="mx-auto" src="/build/assets/img/icons/Vs.png" alt="vs" style="width: 90%; height: auto;" v-show="sideNav !== 'vs'" @click="changeSideNav('vs'); scrollMeTo()">
                    <img class="mx-auto" src="/build/assets/img/icons/VsA.png" alt="vs" style="width: 90%; height: auto;" v-show="sideNav === 'vs'" @click="changeSideNav('vs'); scrollMeTo()">
                  </li>
                </ul>
              </div>
						</div>

						<div class="col-9 index_rightbar mr-0 pl-0" id="index_rightbar" style="height: 90vh; overflow-y: scroll;">
              <div style="height: 130vh;">
                <div class="tab-content game  px-2" style="background-color: rgb(245, 192, 194, .5); min-height: 50vh; border-radius: 20px; height: auto; padding-top: 0.7rem; margin-bottom: 5rem;">
                  <div :class="sideNav === 'football' ? 'active' : ''" v-show="sideNav === 'football'">
                      <img src="/build/assets/img/icons/cards/MMBody.png" alt="slot" style="width: 100%; height: auto; margin-top: -1rem;" @click="$playSound(); $router.push('/body-fb')">
                      <img src="/build/assets/img/icons/cards/MMMaung.png" alt="slot" style="width: 100%; height: auto; margin-top: -3rem;" @click="$playSound(); $router.push('/maung-fb')">
                      <img src="/build/assets/img/icons/cards/ENSBO.png" alt="slot" style="width: 100%; height: auto; margin-top: -3rem;">
                      <img src="/build/assets/img/icons/cards/footballLive.png" alt="slot" style="width: 100%; height: auto; margin-top: -2rem;" @click="$playSound(); $router.push('/live')">
                  </div>

                  <div :class="sideNav === 'card' ? 'active' : ''" v-show="sideNav === 'card'">
                      <img src="/build/assets/img/icons/cards/shankoemee.png" alt="slot" style="width: 99%; margin-left: 0.3rem; height: auto; " @click="$playSound(); changeSideNav('skm')">
                      <img src="/build/assets/img/icons/cards/buGyi.png" alt="slot" style="width: 103%; height: auto; margin-left: -0.5rem; margin-top: -1.5rem;" @click="$playSound(); changeSideNav('bugyi')">
                  </div>

                  <div :class="sideNav === 'vs' ? 'active' : ''" v-show="sideNav === 'vs'">
                    <img src="/build/assets/img/icons/cards/cockFight.png" alt="slot" style="width: 103%; margin-left: -0.4rem; height: auto;" @click="$playSound(); gameInit('CockFight')">
                    <img src="/build/assets/img/icons/cards/abcd.png" alt="slot" style="width: 102%; height: auto; margin-left: -0.3rem; margin-top: -1rem;" @click="$playSound(); fetchBetGame('abcd', 'yoeyar-abcd')">
                    <img src="/build/assets/img/icons/cards/tigerDragon.png" alt="slot" style="width: 100%; height: auto; margin-top: -1.5rem;" @click="$playSound(); fetchBetGame('tiger-dragon', 'yoeyar-dragon-tiger')">
                    <img src="/build/assets/img/icons/cards/myinn.png" alt="slot" style="width: 99%; height: auto; margin-top: -0.8rem; margin-left: 0.2rem;" @click="$playSound(); fetchBetGame('horse', 'yoeyar-horse')">
                  </div>

                  <div :class="sideNav === 'skm' ? 'active' : ''" v-show="sideNav === 'skm'">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/100.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchShanKoMeeData(0)">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/300.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchShanKoMeeData(1)">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/500.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchShanKoMeeData(2)">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/1000.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchShanKoMeeData(3)">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/3000.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchShanKoMeeData(4)">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/5000.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchShanKoMeeData(5)">
                  </div>

                  <div :class="sideNav === 'bugyi' ? 'active' : ''" v-show="sideNav === 'bugyi'">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/100.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchBugyee(0)">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/300.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchBugyee(1)">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/500.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchBugyee(2)">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/1000.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchBugyee(3)">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/3000.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchBugyee(4)">
                    <img class="mx-1 my-1" src="/build/assets/img/icons/rooms/5000.png" alt="skm" style="width: 47.5%; height: auto;" @click="$playSound(); fetchBugyee(5)">
                  </div>

                  <div class="pb-3" :class="sideNav === 'fishing' ? 'active' : ''" v-show="sideNav === 'fishing'">
                    <img src="/build/assets/img/icons/cards/jiliFishing.png" alt="skm" style="width: 50%; height: auto;"  @click="$playSound(); $router.push('/user/fishing?provider=Jili')">
                    <img src="/build/assets/img/icons/cards/jdbFishing.png" class="mt-3" alt="skm" style="width: 50%; height: auto;" @click="$playSound(); $router.push('/user/fishing?provider=JDB')">
                  </div>

                  <div :class="sideNav === 'slot' ? 'active' : ''" v-show="sideNav === 'slot'" class="pb-2">
                    <img src="/build/assets/img/icons/cards/pragmaticPlaySlot.png" alt="skm" style="width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=Pragmatic')">
                    <img src="/build/assets/img/icons/cards/pgSlot.png" alt="skm" style="width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=PGSoft')">
                    <img src="/build/assets/img/icons/cards/jdbSlot.png" alt="skm" style="width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=JDB')">
                    <img src="/build/assets/img/icons/cards/faChaiSlot.png" alt="skm" style="width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=FaChai')">
                    <img src="/build/assets/img/icons/cards/joker.png" alt="skm" style="width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=JOKER')">
                    <img src="/build/assets/img/icons/cards/5G.png" alt="skm" style="width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=5G')">
                    <img src="/build/assets/img/icons/cards/jiliSlot.png" alt="skm" style="width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=Jili')">
                  </div>

                  <div :class="sideNav === 'casino' ? 'active' : ''" v-show="sideNav === 'casino'">
                    <img src="/build/assets/img/icons/cards/sexy.png" alt="casino" style="width: 100%; height: auto;" @click="$playSound(); gameInit('Sexy')">
                    <img src="/build/assets/img/icons/cards/BG Game.png" alt="casino" style="width: 100%; height: auto; margin-top: -2.5rem;" @click="$playSound(); gameInit('BG')">
                    <img src="/build/assets/img/icons/cards/WM Game.png" alt="casino" style="width: 100%; height: auto; margin-top: -2.4rem;" @click="$playSound(); gameInit('WM')">
                    <img src="/build/assets/img/icons/cards/pragmaticPlayCasino.png" alt="casino" style="width: 100%; height: auto; margin-top: 0.1rem;" @click="gameInit('PP Live')">
                  </div>

                  <div :class="sideNav === '2d3d' ? 'active' : ''" v-show="sideNav === '2d3d'">
                    <div class="gwrap_1 pb-3">
                      <img src="/build/assets/img/icons/cards/2D.png" alt="slot" style="width: 100%; height: auto;" @click="$playSound(); $router.push('/user/2d')">
                      <img src="/build/assets/img/icons/cards/3D.png" alt="slot" style="width: 100%; height: auto; margin-top: 0.1rem;" @click="$playSound(); $router.push('/user/3d')">
                      <img src="/build/assets/img/icons/cards/2DLiveIcon.png" alt="slot" style="width: 100%; height: auto; " @click="$playSound(); $router.push('/user/2d/home')">
                      <img src="/build/assets/img/icons/cards/3DLiveIcon.png" alt="slot" style="margin-left: 0.4rem; width: 96%; height: auto; margin-top: 0.3rem;" @click="$playSound(); $router.push('/user/3d/home')">
                    </div>
                  </div>
                  <!-- <div class="tab-pane" :class="sideNav === '2d3d' ? 'active' : ''">
                    <div class="gwrap_1">
                      <img src="/build/assets/img/icons/2D.png" alt="slot" style="width: 50%; height: auto;">
                      <img src="/build/assets/img/icons/3D.png" alt="slot" style="width: 50%; height: auto;">
                    </div>
                  </div>
                  <div class="tab-pane" :class="sideNav === '2d3d' ? 'active' : ''">
                    <div class="gwrap_1">
                      <img src="/build/assets/img/icons/2D.png" alt="slot" style="width: 50%; height: auto;">
                      <img src="/build/assets/img/icons/3D.png" alt="slot" style="width: 50%; height: auto;">
                    </div>
                  </div>
                  <div class="tab-pane" :class="sideNav === '2d3d' ? 'active' : ''">
                    <div class="gwrap_1">
                      <img src="/build/assets/img/icons/2D.png" alt="slot" style="width: 50%; height: auto;">
                      <img src="/build/assets/img/icons/3D.png" alt="slot" style="width: 50%; height: auto;">
                    </div>
                  </div>
                  <div class="tab-pane" :class="sideNav === '2d3d' ? 'active' : ''">
                    <div class="gwrap_1">
                      <img src="/build/assets/img/icons/2D.png" alt="slot" style="width: 50%; height: auto;">
                      <img src="/build/assets/img/icons/3D.png" alt="slot" style="width: 50%; height: auto;">
                    </div>
                  </div>
                  <div class="tab-pane" :class="sideNav === '2d3d' ? 'active' : ''">
                    <div class="gwrap_1">
                      <img src="/build/assets/img/icons/2D.png" alt="slot" style="width: 50%; height: auto;">
                      <img src="/build/assets/img/icons/3D.png" alt="slot" style="width: 50%; height: auto;">
                    </div>
                  </div> -->

                </div>
              </div>
						</div>
					<!-- </div> -->
      </div>
    </div>

    <van-overlay :show="isLoading">
        <div class="wrapper" @click.stop>
          <van-loading type="spinner" color="#ffffff" class="mx-auto"/>
        </div>
    </van-overlay>
  </div>
</template>
<script>
import NavBar from '@/layouts/NavBar.vue';
import { NoticeBar, Dialog, Toast, Sticky } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { NoticeBar, Sticky },
  data() {
    return {
      isLoading: false,
      twoDdata: {},
      twoDHistories: {},
      threeDHistories: {},
      threedData: {},
      websiteInfo: {},
      isLogged: false,
      sideNav: '2d3d'
    };
  },
  methods: {
    scrollMeTo(refName) {
      document.getElementById('index_rightbar').scrollTo({
        top: 0,
        behavior: 'smooth'  // This creates the smooth scrolling effect
      })
    },
    async fetchBetGame(game = null, link = null) {
      try {
        this.isLoading = true;
        
        if(game){
            this.gameName = game
            this.gameLink = link
        }
            const res = await axios.get(`/${this.gameName}-data`, {
            params: {
                    id : this.$store.state.authUser.name,
                    balance : this.$store.state.authUser.amount,
                    info : {
                            nickname : this.$store.state.authUser.user_name,
                            profile : 3
                        }
                    }
            });
            window.location.assign(`https://${link}.vercel.app/?id=${this.$store.state.authUser.name}&passcode=${res.data.passcode}&exit=https%3A%2F%2F${window.location.host}/home`)
            this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    async fetchBugyee(level = null) {
      try {
        const amount = this.$store.state.authUser.amount;
        this.isLoading = true;
        if(level == 0 && amount < 1000){
            this.limitText = "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
        if(level == 1 && amount < 3000){
            this.limitText = "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
        if(level == 2 && amount < 5000){
            this.limitText = "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
        if(level == 3 && amount < 10000){
            this.limitText = "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
        if(level == 4 && amount < 30000){
            this.limitText = "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
        if(level == 5 && amount < 50000){
            this.limitText = "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
            const res = await axios.get('/bugyee-new-data', {
            params: {
                    id : this.$store.state.authUser.name,
                    level,
                    balance : this.$store.state.authUser.amount,
                    info : {
                            nickname : this.$store.state.authUser.user_name,
                            profile : 3
                        }
                    }
            });
            window.location.assign(`http://165.22.110.56/bugyee_game/?id=${this.$store.state.authUser.name}&passcode=${res.data.passcode}&exit=https%3A%2F%2F${window.location.host}/user/bugyee-rooms`)
            this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    async fetchShanKoMeeData(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }
        
        const amount = authUser.amount;
        if(level == 0 && amount < 1000){
            this.limitText = "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
        if(level == 0 && amount > 100000){
            this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }

        if(level == 1 && amount < 3000){
            this.limitText = "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
        if(level == 1 && amount > 300000){
            this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }

        if(level == 2 && amount < 5000){
            this.limitText = "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
        if(level == 2 && amount > 500000){
            this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
        
        if(level == 3 && amount < 10000){
            this.limitText = "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
        if(level == 4 && amount < 30000){
            this.limitText = "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }
        if(level == 5 && amount < 50000){
            this.limitText = "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
            $('#limit').modal('show');
            this.isLoading = false;
            return false;
        }

        // if(this.nickname && this.nickname !== ''){
            const res = await axios.get('/shankomee-data', {
            params: {
                    id : this.$store.state.authUser.name,
                    level,
                    balance : this.$store.state.authUser.amount,
                    info : {
                            nickname : this.$store.state.authUser.user_name,
                            profile : 3
                        }
                    }
            });
            window.location.assign(`https://yoeyar-skm.vercel.app?id=${this.$store.state.authUser.name}&passcode=${res.data.passcode}&exit=https%3A%2F%2F${window.location.host}/user/skm-rooms`)
            this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async gameInit(game) {
    try {
      this.isLoading = true;
      const authUser = await this.fetchUser();
      if (!authUser) {
        this.$router.push('/auth/login');
      }
      
      const res = await axios.get('/games/url', {
        params: {
          provider: game
        },
      });
      
      window.open(res.data.data.gameUrl, "_self");
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      // this.$router.go();
    }
  },

    changeSideNav(para) {
      this.sideNav = para;
    },
    ...mapActions(['logoutUser', 'fetchUser']),
    async redirectRoute(path, query = null) {
      try {
        console.log('query', query)
        if(query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },

    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push('/auth/login');
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => {});
    },
    async redirectRoute(path, query = null) {
      try {
        if (path === 'tip') {
          const text = this.$store.state.language === 'en'
            ? 'This feature is not support yet.'
            : 'ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။';
          Dialog.alert({
            message: text,
            confirmButtonText:
                    this.$store.state.language === 'en'
                      ? 'Okay'
                      : 'Okay',
          }).then(() => {
          // on close
          });
        } else if(query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },
    threedDrawDateFormat(date) {
      return moment(date).format('ll');
    },
    async fetchTwoDdata() {
      try {
        const res = await axios.get('/2d/data');
        this.isLive = res.data.data[0].isLive;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get('/website-infos');
        this.websiteInfo = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchThreedDdata() {
      try {
        const res = await axios.get('/3d/data');
        this.threedData = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoThreeDHistories() {
      try {
        const twoDres = await axios.get('/twod_history');
        const threeDres = await axios.get('/threed_history');
        this.twoDHistories = twoDres.data.data;
        this.threeDHistories = threeDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (authUser) {
      this.isLogged = true;
    }
    this.fetchWebsiteData();
    // this.fetchUser();
    // this.fetchTwoDdata();
    // this.fetchThreedDdata();
    // this.fetchTwoThreeDHistories();
  },
};
</script>
<style scoped>
.sidebar {
    position: fixed;
    /* top: 23.5rem; */
    left: 0;
    height: 55vh;
    padding-bottom: 50px;
    scrollbar-width: none; /* For Firefox */
    -ms-overflow-style: none; /* For Internet Explorer and Edge */
    overflow-y: auto;
}
.index_rightbar {
    padding: 0px 10px;
    overflow-y: scroll;
    height: 55vh;
    scrollbar-width: none; /* For Firefox */
    -ms-overflow-style: none; /* For Internet Explorer and Edge */
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.detail-button {
  appearance: none;
  background-color: transparent;
  border: 2px solid #714DC7;
  text-transform: uppercase;
  border-radius: 10px;
  box-sizing: border-box;
  color: #714DC7;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background-color: #714DC7;
  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
}

.nav-pills.game-nav {
    padding-right: 5px;
  }
  .nav-pills .nav-link {
    border-radius: 10px !important;
    margin-bottom: 5px;
    /* padding: 10px; */
    font-size: 10px !important;
    text-align: center;
    color: #ffffff;
    /* background: linear-gradient(#aa9ace, #714DC7); */
  }
  .nav-pills:not(.nav-pills-circle) .nav-item {
        padding-right: 0;
        margin-bottom: 0;
        width: 100px;
    }

  .nav-pills .nav-link img {
    width: 18px !important;
    /* margin-right: 10px; */
    padding-bottom: 4px;
  }
  .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: #fff !important;
        background: linear-gradient(#fff, #8a69d9);
}

.nav {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}

.tab-content.game a img {
    /* box-shadow: 0px 3px 14px -5px rgba(0, 0, 0, 0.4); */
    border-radius: 21px;
    margin-bottom: 10px;
    width: 100%;
}
.tab-content.game {
    padding-left: 3px;
}
.tab-content>.tab-pane {
    display: none;
    padding-right: 3px;
}
.tab-content>.active {
    display: block;
}


.css-38745a {
    margin: 0px;
    line-height: 1.5;
    font-size: 12px;
    font-family: NotoSansMyanmar;
    font-weight: 500;
}
.css-17h40hp {
    margin: 0px;
    line-height: 1.5;
    font-size: 14px;
    font-family: NotoSansMyanmar;
    font-weight: 700 !important;
}
.card {
  cursor: pointer;
  border-radius: 10px !important;
}
.main-image-wrapper img {
  width: 100%;
}
.video-container {
  height: 500px;
  width: 100%;
}
.notice-bar {
  margin-top: -40px;
  z-index: 1;
  font-size: 20px;
  color: #172b4c;
  background: linear-gradient(#aa9ace, #714DC7);
}
.twod-threed-cards {
  height: 200px;
}
.live-number {
  font-weight: bold;
  font-size: 25px;
}
.live-result {
  font-weight: bolder;
  font-size: 60px;
  animation-name: live-number-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.not-live-text {
  font-weight: bold;
  font-size: 24px;
}
.cards-container {
  display: flex;
  flex-wrap: wrap;
}
.card-body {
  padding: 0px !important;
}
.cards-container-mobile {
  display: none;
}
@keyframes live-number-animation {
  from {
    color: white;
  }
  to {
    color: red;
  }
}

@media (max-width: 768px) {
  /* .middle-container {
    padding-top: 0.1rem !important;
  } */
  hr {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .video-container {
    height: 300px;
    width: 100%;
  }
  .main-wrapper {
    padding: 7px !important;
  }
  .notice-bar {
    margin-top: 0px;
    height: 25px;
    z-index: 1;
    font-size: 12px;
    color: #ffffff;
    background: #D02126;
    border-radius: 7px;
  }
  .live-number {
    font-weight: bold;
    font-size: 20px;
  }
  .live-result {
    font-weight: bolder;
    font-size: 37px;
  }

  .cards-container {
    display: none;
  }
  .cards-container-mobile {
    padding: 0px !important;
    margin-top: 5px !important;
    display: flex;
    flex-wrap: wrap;
  }
  .home-cards {
    padding-left: 10px;
    padding-right: 10px;
  }
  .card-body {
    padding: 0px !important;
  }
  .not-live-text {
    font-size: 18px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .account-container-wrapper {
    width: auto;
    height: auto;
    border-radius: 10px;
    padding-left: 4px;
    padding-right: 4px;
    margin-top: 10px !important;
    margin-left: 10px; 
    margin-right: 10px;
    color: #000000;
    /* background: linear-gradient(#aa9ace, #714DC7); */
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  }
  .top-wrapper,
  .bottom-wrapper {
    padding: 10px;
    width: 100%;
    display: flex;
  }
  .top-right,
  .bottom-right {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: end;
  }
  .top-left,
  .bottom-left {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: start;
  }
}
</style>
